import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import layoutWeb from '@/layoutWeb'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index'),
    meta: { title: '首页' },
    hidden: true
  },
  {
    path: '/product',
    component: layoutWeb,
    redirect: '/product/index',
    hidden: true,
    meta: { title: '产品案例' },
    children: [
      {
        path: 'index',
        name: 'product',
        component: () => import('@/views/product/index'),
        meta: { title: '产品案例' },
      },
      {
        path: 'detail:id',
        name: 'productDetail',
        component: () => import('@/views/product/detail'),
        meta: { title: '产品详情' },
        props:true
      }
    ]
  },
  {
    path: '/yybc',
    component: layoutWeb,
    redirect: '/yybc/index',
    hidden: true,
    meta: { title: '药育本草' },
    children: [
      {
        path: 'index',
        name: 'yybc',
        component: () => import('@/views/yybc/index'),
        meta: { title: '药育本草' }
      },
      {
        path: 'detail:id',
        name: 'yybcDetail',
        component: () => import('@/views/yybc/detail'),
        meta: { title: '本草详情' },
        props:true
      }
    ]
  },
  {
    path: '/news',
    component: layoutWeb,
    redirect: '/news/index',
    hidden: true,
    meta: { title: '新闻资讯' },
    children: [
      {
        path: 'index',
        name: 'news',
        component: () => import('@/views/news/index'),
        meta: { title: '新闻资讯' }
      },
      {
        path: 'detail:id',
        name: 'newDetail',
        component: () => import('@/views/news/detail'),
        meta: { title: '资讯详情' },
        props:true
      }
    ]
  },
  // {
  //   path: '/purchase',
  //   component: layoutWeb,
  //   redirect: '/purchase/index',
  //   hidden: true,
  //   meta: { title: '直采专区' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'purchase',
  //       component: () => import('@/views/purchase/index'),
  //       meta: { title: '直采专区' }
  //     },
  //     {
  //       path: 'detail:id',
  //       name: 'purchaseDetail',
  //       component: () => import('@/views/purchase/detail'),
  //       meta: { title: '商品详情' },
  //       props:true
  //     }
  //   ]
  // },
  {
    path: '/award',
    name: 'Award',
    component: () => import('@/views/Award/index'),
    meta: { title: '中奖名单' },
    hidden: true
  },
]

// 需要根据用户角色动态加载的路由
export const asyncRoutes = [
  {
    path: '/adminBanner',
    redirect: '/adminBanner/index',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/adminBanner/index'),
        name: 'adminBanner',
        meta: { title: 'banner', icon: 'component', roles: ['admin'] }
      }
    ]
  },
  {
    path: '/adminNews',
    redirect: '/adminNews/index',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/adminNews/index'),
        name: 'adminNews',
        meta: { title: '新闻资讯', icon: 'clipboard', roles: ['admin'] }
      }
    ]
  },
  {
    path: '/adminYybc',
    redirect: '/adminYybc/index',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/adminYybc/index'),
        name: 'adminYybc',
        meta: { title: '药育本草', icon: 'form', roles: ['admin'] }
      }
    ]
  },
  {
    path: '/adminProduct',
    redirect: '/adminProduct/type',
    component: Layout,
    meta: { title: '产品与服务', icon: 'table', roles: ['admin'] },
    children: [
      {
        path: 'type',
        component: () => import('@/views/adminProduct/type'),
        name: 'adminType',
        meta: { title: '产品类型' }
      },
      {
        path: 'case:tid',
        hidden: true,
        component: () => import('@/views/adminProduct/case'),
        name: 'adminCase',
        meta: { title: '产品案例' },
        props: true
      }
    ]
  },

  {
    path: 'link',
    component: Layout,
    children: [
      {
        path: '/',
        meta: { title: '官网入口', icon: 'link' }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

// 创建一个router实例
const createRouter = () => new Router({
  mode: 'history', // require service support
  // 滚动到顶部
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  // router.matcher替换现有router的routes
  router.matcher = newRouter.matcher // reset router
}

// router.selfaddRoutes = function (params) {
//   router.matcher = new Router().matcher;
//   router.addRoutes(params)
// }
export default router
